import { useActor } from '@xstate/react';
import classNames from 'classnames';
import React from 'react';
import { ActorRef, DoneInvokeEvent } from 'xstate';
import { STATES as RECORDER_STATES, RecorderInterface } from '../interfaces/recorderInterface';
import { TAKE_TYPES } from '../interfaces/storageInterface';
import { VIDEO_STATUS } from '../interfaces/videoInterface';
import { IWidgetMachineProps, STATES as WIDGET_STATES, TAGS as WIDGET_TAGS } from '../interfaces/widgetInterface';
import { CountDown } from './CountDown';
import { Header } from './Header';
import { PracticeModeInfo } from './PracticeModeInfo';
import { Question } from './Question';
import { QuestionsList } from './QuestionsList';
import { Setup } from './Setup';
import { Upload } from './Upload';

interface IProps extends IWidgetMachineProps {
  recorderRef: ActorRef<DoneInvokeEvent<any>, any>;
}

export const OuterView:React.FC<IProps> = ({ widgetMachine, sendToWidget, recorderRef }) => {
  const {
    questions, currentQuestion, widgetConfig: { job, video, company, config }, recordingType, isConnected, totalFileSize, totalUploadedFilesSize, totalUploadSpeed,
  } = widgetMachine.context;
  const [recorderMachine] = useActor(recorderRef);
  const { countdown, recordWithoutVideo } = recorderMachine.context as RecorderInterface;

  const currentQuestionObj = questions[currentQuestion - 1];
  const isOuterViewDisplayed = widgetMachine.hasTag(WIDGET_TAGS.DISPLAY_OUTER_VIEW);
  const isSetupState = widgetMachine.matches(WIDGET_STATES.SETUP);
  const isVideoQuestionState = widgetMachine.matches({ [WIDGET_STATES.INTERVIEW]: WIDGET_STATES.INTERVIEW__VIDEO_QUESTION });
  const isAssessmentState = widgetMachine.matches({ [WIDGET_STATES.INTERVIEW]: WIDGET_STATES.INTERVIEW__ASSESSMENT });
  const isQuestionDisplayed = widgetMachine.hasTag(WIDGET_TAGS.DISPLAY_QUESTION) || (isVideoQuestionState && !currentQuestionObj.thinkingTime);
  const isPreviewState = widgetMachine.matches(WIDGET_STATES.PREVIEW);
  const isUploadingState = widgetMachine.matches(WIDGET_STATES.UPLOADING);
  const isQuestionsListDisplayed = widgetMachine.hasTag(WIDGET_TAGS.DISPLAY_QUESTIONS_LIST);
  const isUploadDisplayed = widgetMachine.hasTag(WIDGET_TAGS.DISPLAY_UPLOAD);
  const isRecording = recorderMachine.matches({ [RECORDER_STATES.RECORDING]: RECORDER_STATES.COLLECTING_BLOBS });
  const isCountDown = recorderMachine.matches({ [RECORDER_STATES.RECORDING]: RECORDER_STATES.COUNT_DOWN });
  const isPracticeMode = recordingType === TAKE_TYPES.PRACTICE;
  const questionsStatus = video?.videos?.map((v, idx) => (v.uploaded || (v.completed && currentQuestion > idx + 1) ? VIDEO_STATUS.COMPLETED : VIDEO_STATUS.INCOMPLETED)) || [];

  const outerViewClassNames = classNames({
    'myinterview-widget-outer': true,
    'myinterview-widget-outer--hidden': !isOuterViewDisplayed || isAssessmentState,
    'myinterview-widget-outer--hide-question': !isRecording && !isAssessmentState && !isUploadingState && !isPreviewState && (!isVideoQuestionState || !!currentQuestionObj.thinkingTime), // TODO: improve logic
    'myinterview-widget-outer--uploading': isUploadingState,
  });

  return (
    <div className={outerViewClassNames}>

      <Header logo={job?.logo || ''} companyName={job?.company || company?.name || ''} jobTitle={job?.title || ''} forDesktopLayout />

      {isPracticeMode && !isSetupState && (
        <PracticeModeInfo />
      )}

      {isCountDown && <CountDown countDown={countdown} />}

      {isSetupState && <Setup recordWithoutVideo={recordWithoutVideo} widgetMachine={widgetMachine} sendToWidget={sendToWidget} isPracticeDisabled={!!config.disablePractice} />}

      {isQuestionsListDisplayed && <QuestionsList questions={questions} currentQuestion={currentQuestion} isPracticeMode={isPracticeMode} questionsStatus={questionsStatus} />}

      {isQuestionDisplayed && <Question questionObj={currentQuestionObj} />}

      {isUploadDisplayed && (
        <Upload
          isConnected={isConnected}
          totalFileSize={totalFileSize}
          totalUploadedFilesSize={totalUploadedFilesSize}
          totalUploadSpeed={totalUploadSpeed}
        />
      )}

    </div>
  );
};
